'use client'

import { Domains } from 'monitoring/constants/domains'
import { useLog } from 'monitoring/sendLog/client/useLog'
import { useCIAM } from 'security/hooks/CIAM/useCIAM/useCIAM'
import { ActionTypes } from 'security/types/CIAM'
import { useSetSession } from 'session/src/hooks/useSetSession'
import { setSessionCacheStorage } from 'session/src/utils/cacheStorage/setSessionCacheStorage'

import { logout as logoutService } from '../services/logout'

export const useLogout = () => {
	const setSession = useSetSession()
	const { action, clear } = useCIAM()
	const { sendLog } = useLog()

	const logout = async (): Promise<void> => {
		try {
			await action(ActionTypes.LOGOUT)
			const response = await logoutService()

			if (response) {
				if (response.token) {
					await setSessionCacheStorage(response)
					setSession({ ...response, isReady: true })
					clear()
				}
			} else {
				sendLog({
					domain: Domains.logout,
					message: '[Auth Orquestrator Service] error logout',
				})
			}
		} catch (error) {
			sendLog({
				domain: Domains.logout,
				message: `[${Domains.logout}]: ${error}`,
			})
		}
	}

	return { logout }
}
